const products = [
  {
    id: 1,
    name: 'Wireless Noise Cancelling Headphones',
    price: 2999,
    originalPrice: 3999,
    category: 'Audio',
    brand: 'Sony',
    rating: 4.5,
    reviews: 128,
    stock: 15,
    description: 'Premium wireless headphones with active noise cancellation, 30-hour battery life, and crystal-clear sound quality.',
    features: ['Active Noise Cancellation', '30-hour Battery Life', 'Bluetooth 5.0', 'Touch Controls'],
    images: [
      'https://assets.bosecreative.com/transform/775c3e9a-fcd1-489f-a2f7-a57ac66464e1/SF_QCUH_deepplum_gallery_1_816x612_x2?quality=90&io=width:400,height:300,transform:fit&io=width:400,height:300,transform:fit',
      'https://th.bing.com/th/id/OIP.48HU2jZl8bVwdO2sRd70tgHaLE?w=127&h=190&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3',
      'https://th.bing.com/th/id/OIP.KByw2xbPIij4qBGDFwCb4AHaHU?w=180&h=180&c=7&r=0&o=5&dpr=1.3&pid=1.7'
    ],
    image: 'https://assets.bosecreative.com/transform/775c3e9a-fcd1-489f-a2f7-a57ac66464e1/SF_QCUH_deepplum_gallery_1_816x612_x2?quality=90&io=width:400,height:300,transform:fit&io=width:400,height:300,transform:fit',
    isNew: true,
    isOnSale: true,
    discount: 25
  },
  {
    id: 2,
    name: 'Smart Fitness Watch',
    price: 4999,
    originalPrice: 5999,
    category: 'Wearables',
    brand: 'Apple',
    rating: 4.8,
    reviews: 256,
    stock: 8,
    description: 'Advanced fitness tracking with heart rate monitoring, GPS, and water resistance up to 50m.',
    features: ['Heart Rate Monitor', 'GPS Tracking', 'Water Resistant', 'Sleep Tracking'],
    images: [
      'https://cdn.mos.cms.futurecdn.net/Pk5ydxYo6ty2Q4SX9vznP6.jpg',
      'https://th.bing.com/th/id/OIP.R6FupRfwXfROVUWKw6AttwHaHa?w=165&h=180&c=7&r=0&o=5&dpr=1.3&pid=1.7',
      'https://th.bing.com/th/id/OIP.mX7QHcAE0a1780PFLvqUgQHaHa?w=185&h=185&c=7&r=0&o=5&dpr=1.3&pid=1.7'
    ],
    image: 'https://cdn.mos.cms.futurecdn.net/Pk5ydxYo6ty2Q4SX9vznP6.jpg',
    isNew: false,
    isOnSale: true,
    discount: 17
  },
  {
    id: 3,
    name: 'Portable Bluetooth Speaker',
    price: 1999,
    originalPrice: 2499,
    category: 'Audio',
    brand: 'JBL',
    rating: 4.3,
    reviews: 89,
    stock: 22,
    description: 'Compact portable speaker with 360-degree sound, waterproof design, and 12-hour playback.',
    features: ['360° Sound', 'Waterproof', '12-hour Battery', 'Party Mode'],
    images: [
      'https://storio.in/cdn/shop/files/71kl33XC3pL.jpg?v=1736418030',
      'https://th.bing.com/th/id/OIP.SHZGf1Yr9LEoogHfxSlvawHaG_?w=223&h=210&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3',
      'https://th.bing.com/th/id/OIP.fqNrBBC9NyjOaZmIjEI5FgHaHa?w=208&h=209&c=7&r=0&o=5&dpr=1.3&pid=1.7'
    ],
    image: 'https://storio.in/cdn/shop/files/71kl33XC3pL.jpg?v=1736418030',
    isNew: false,
    isOnSale: false,
    discount: 0
  },
  {
    id: 4,
    name: 'RGB Gaming Mouse',
    price: 1499,
    originalPrice: 1999,
    category: 'Accessories',
    brand: 'Logitech',
    rating: 4.6,
    reviews: 167,
    stock: 12,
    description: 'High-precision gaming mouse with customizable RGB lighting and programmable buttons.',
    features: ['RGB Lighting', 'Programmable Buttons', 'High DPI Sensor', 'Ergonomic Design'],
    images: [
      'https://archertechlab.com/cdn/shop/products/400-3_1200x1200_crop_center.png?v=1750658032',
      'https://th.bing.com/th/id/OIP.xqCqw-VCxJGHBTBsn0rqoAHaHa?w=182&h=194&c=7&r=0&o=5&dpr=1.3&pid=1.7',
      'https://th.bing.com/th/id/OIP.ISOH56C926uEmeSrjyaqKgHaHa?w=171&h=180&c=7&r=0&o=5&dpr=1.3&pid=1.7'
    ],
    image: 'https://archertechlab.com/cdn/shop/products/400-3_1200x1200_crop_center.png?v=1750658032',
    isNew: true,
    isOnSale: true,
    discount: 25
  },
  {
    id: 5,
    name: '4K Ultra HD Smart TV',
    price: 45999,
    originalPrice: 54999,
    category: 'Electronics',
    brand: 'Samsung',
    rating: 4.7,
    reviews: 342,
    stock: 5,
    description: '55-inch 4K Ultra HD Smart TV with HDR, built-in streaming apps, and voice control.',
    features: ['4K Ultra HD', 'HDR Technology', 'Smart TV', 'Voice Control'],
    images: [
      'https://aws-obg-image-lb-3.tcl.com/content/dam/iffalcon/product/tv/s-series/s53/id-image/2.png',
      'https://th.bing.com/th/id/OIP.xzyKY821CGOco9-KyPqkUQAAAA?w=157&h=159&c=7&r=0&o=5&dpr=1.3&pid=1.7',
      'https://th.bing.com/th/id/OIP.SNDLmhQGCKOCqqklnjErNAHaIJ?w=169&h=186&c=7&r=0&o=5&dpr=1.3&pid=1.7'
    ],
    image: 'https://aws-obg-image-lb-3.tcl.com/content/dam/iffalcon/product/tv/s-series/s53/id-image/2.png',
    isNew: false,
    isOnSale: true,
    discount: 16
  },
  {
    id: 6,
    name: 'Wireless Mechanical Keyboard',
    price: 3499,
    originalPrice: 4299,
    category: 'Accessories',
    brand: 'Corsair',
    rating: 4.4,
    reviews: 94,
    stock: 18,
    description: 'Premium mechanical keyboard with Cherry MX switches, RGB backlighting, and wireless connectivity.',
    features: ['Cherry MX Switches', 'RGB Backlighting', 'Wireless', 'Aluminum Frame'],
    images: [
      'https://pinkgaming.shop/cdn/shop/files/pink-cute-cat-design-wireless-mechanical-keyboard_2048x.jpg?v=1724946951',
      'https://th.bing.com/th/id/OIP.UuX53Mn_JxaAWW5TlJSh-wHaFj?w=269&h=202&c=7&r=0&o=5&dpr=1.3&pid=1.7',
      'https://th.bing.com/th/id/OIP.LrsLEI8Lj4b4wOwQdgpT0gHaHa?w=185&h=185&c=7&r=0&o=5&dpr=1.3&pid=1.7'
    ],
    image: 'https://pinkgaming.shop/cdn/shop/files/pink-cute-cat-design-wireless-mechanical-keyboard_2048x.jpg?v=1724946951',
    isNew: true,
    isOnSale: false,
    discount: 0
  },
  {
    id: 7,
    name: 'Action Camera',
    price: 8999,
    originalPrice: 10999,
    category: 'Electronics',
    brand: 'GoPro',
    rating: 4.9,
    reviews: 203,
    stock: 7,
    description: '4K action camera with image stabilization, waterproof case, and 360-degree capture.',
    features: ['4K Recording', 'Image Stabilization', 'Waterproof', '360° Capture'],
    images: [
      'https://cameraclub.in/cdn/shop/files/Untitleddesign_5_95ac4bcc-c06f-44fd-b8de-d456a1ee0a39.png?v=1713357560',
      'https://th.bing.com/th/id/OIP.8BS0GZaxiwphsvCaV_nobgHaEK?w=311&h=180&c=7&r=0&o=5&dpr=1.3&pid=1.7',
      'https://ts3.mm.bing.net/th?id=OIP.byD8ysx7Qy-pZeY8tSo5pQHaE8&pid=15.1'
    ],
    image: 'https://cameraclub.in/cdn/shop/files/Untitleddesign_5_95ac4bcc-c06f-44fd-b8de-d456a1ee0a39.png?v=1713357560',
    isNew: false,
    isOnSale: true,
    discount: 18
  },
  {
    id: 8,
    name: 'Wireless Earbuds',
    price: 2499,
    originalPrice: 2999,
    category: 'Audio',
    brand: 'Apple',
    rating: 4.6,
    reviews: 189,
    stock: 25,
    description: 'True wireless earbuds with active noise cancellation and spatial audio technology.',
    features: ['Active Noise Cancellation', 'Spatial Audio', 'Wireless Charging', 'Sweat Resistant'],
    images: [
      'https://www.zdnet.com/a/img/resize/f00be25dc9dbc38bb2d31641e69e33139d9ab53a/2024/02/14/07e7dfb9-8c65-4d03-a629-b9fc36f42bfd/dsc01521-2.jpg?auto=webp&fit=crop&height=675&width=1200',
      'https://th.bing.com/th/id/OIP.d0uy98hu_2fYWLP2DHKb4wHaHa?w=185&h=186&c=7&r=0&o=5&dpr=1.3&pid=1.70',
      'https://th.bing.com/th/id/OIP.i_0MyUcCXVZpY78Gw8PDwgHaHa?w=186&h=186&c=7&r=0&o=5&dpr=1.3&pid=1.7'
    ],
    image: 'https://www.zdnet.com/a/img/resize/f00be25dc9dbc38bb2d31641e69e33139d9ab53a/2024/02/14/07e7dfb9-8c65-4d03-a629-b9fc36f42bfd/dsc01521-2.jpg?auto=webp&fit=crop&height=675&width=1200',
    isNew: false,
    isOnSale: true,
    discount: 17
  },
  {
    id: 9,
    name: 'Android Tablet 10.1"',
    price: 15999,
    originalPrice: 18999,
    category: 'Electronics',
    brand: 'Samsung',
    rating: 4.4,
    reviews: 112,
    stock: 14,
    description: '10.1-inch Android tablet with HD display, long battery life, and fast performance for work and play.',
    features: ['10.1" HD Display', 'Octa-core Processor', 'Long Battery', 'Expandable Storage'],
    images: [
      'https://www.digitaltrends.com/wp-content/uploads/2024/06/lenovo-tab-plus-2024-official-1.jpg?fit=720%2C479&p=1',
      'https://th.bing.com/th/id/OIP.RTerm_ulfOfeEW387NAYfgHaE8?w=284&h=189&c=7&r=0&o=5&dpr=1.3&pid=1.7'
    ],
    image: 'https://www.digitaltrends.com/wp-content/uploads/2024/06/lenovo-tab-plus-2024-official-1.jpg?fit=720%2C479&p=1',
    isNew: true,
    isOnSale: false,
    discount: 0
  },
  {
    id: 10,
    name: 'Gaming Headset Pro',
    price: 3499,
    originalPrice: 3999,
    category: 'Audio',
    brand: 'Corsair',
    rating: 4.7,
    reviews: 98,
    stock: 20,
    description: 'Surround sound gaming headset with noise-cancelling mic and RGB lighting.',
    features: ['Surround Sound', 'Noise Cancelling Mic', 'RGB Lighting', 'Comfort Fit'],
    images: [
      'https://www.eksa.net/cdn/shop/files/E900ProYellow_5104bed1-2393-4a32-93b0-c02bb12c0f20.png?v=1706768415&width=720',
      'https://th.bing.com/th/id/OIP.nnWQ9M4LY7cHJPkKYbIJ8gHaHa?w=188&h=199&c=7&r=0&o=5&dpr=1.3&pid=1.7'
    ],
    image: 'https://www.eksa.net/cdn/shop/files/E900ProYellow_5104bed1-2393-4a32-93b0-c02bb12c0f20.png?v=1706768415&width=720',
    isNew: true,
    isOnSale: true,
    discount: 12
  },
  {
    id: 11,
    name: 'DSLR Camera 24MP',
    price: 39999,
    originalPrice: 45999,
    category: 'Electronics',
    brand: 'Canon',
    rating: 4.8,
    reviews: 67,
    stock: 6,
    description: '24MP DSLR camera with fast autofocus, Wi-Fi, and full HD video recording.',
    features: ['24MP Sensor', 'Wi-Fi', 'Full HD Video', 'Fast Autofocus'],
    images: [
      'https://i.reincubate.com/i/mirrorless-dslr-cover.png',
      'https://th.bing.com/th/id/OIP.vKrQDUvxb9lLxFZl3a0Y6QHaHa?w=195&h=195&c=7&r=0&o=5&dpr=1.3&pid=1.7'
    ],
    image: 'https://i.reincubate.com/i/mirrorless-dslr-cover.png',
    isNew: false,
    isOnSale: true,
    discount: 13
  },
  {
    id: 12,
    name: 'Power Bank 20000mAh',
    price: 1499,
    originalPrice: 1999,
    category: 'Accessories',
    brand: 'Mi',
    rating: 4.5,
    reviews: 154,
    stock: 30,
    description: 'High-capacity 20000mAh power bank with fast charging and dual USB output.',
    features: ['20000mAh', 'Fast Charging', 'Dual USB', 'Slim Design'],
    images: [
      'https://www.mytrendyphone.eu/images/Cyke-P1-Plus-Wireless-Power-Bank-20000mAh-Green-15092020-01-p.webp',
      'https://th.bing.com/th/id/OIP.Ftk21Win7RXvMdxPyDufswHaHa?w=193&h=193&c=7&r=0&o=5&dpr=1.3&pid=1.7'
    ],
    image: 'https://www.mytrendyphone.eu/images/Cyke-P1-Plus-Wireless-Power-Bank-20000mAh-Green-15092020-01-p.webp',
    isNew: false,
    isOnSale: false,
    discount: 0
  },
  {
    id: 13,
    name: 'Smart Home Speaker',
    price: 2999,
    originalPrice: 3499,
    category: 'Audio',
    brand: 'Google',
    rating: 4.6,
    reviews: 88,
    stock: 17,
    description: 'Voice-controlled smart speaker with Google Assistant and multi-room audio.',
    features: ['Voice Control', 'Google Assistant', 'Multi-room Audio', 'Wi-Fi'],
    images: [
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTGCCWx0g1gSB1F1U47Aoy0N4c8gZ1e2imLdA&s',
      'https://ts2.mm.bing.net/th?id=OIP.JqL6k04oLoN060V0XG-A9QHaGL&pid=15.1'
    ],
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTGCCWx0g1gSB1F1U47Aoy0N4c8gZ1e2imLdA&s',
    isNew: true,
    isOnSale: true,
    discount: 14
  }
];

export default products;
